// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Hh-R","content":"RecentSearches_content__8t1aO"};